export const HOMEOWNERS_STRINGS = {
  'meta.title': 'Property Management Reimagined | Belong',
  'meta.title.withRegion':
    '{regionName} Property Management Reimagined | Belong',
  'meta.description':
    'Property management the way it should have been all along. Get guaranteed rent and a dedicated team of experts to manage everything about your rental home.',
  'meta.description.withRegion':
    '{regionName} rental home property management the way it should have been all along. Get guaranteed rent, lower vacancy, financing, and more with Belong.',
  'cover.titles.firstText': 'guaranteed rent.',
  'cover.titles.secondText': 'fully-vetted Residents.',
  'cover.titles.thirdText': 'Pros at your fingertips.',
  'cover.titles.fourthText': 'one-click financing.',
  'cover.titles.fifthText': '24/7 support.',
  'cover.titles.sixthText': '360° wealth insights.',
  'cover.titles.seventhText': 'guaranteed time to rent.',
  'cover.subtitle': '{region} Property Management Made\u00a0Loveable',
  'cover.subtitle-no-region': 'Property Management Made\u00a0Loveable',
  'cover.addressPlaceholder': 'Enter Your Rental Home Address',
  'cover.unitPlaceholder': 'Unit',
  'cover.ctaLabel': 'Get Started',
  'videoSection.title': 'We manage everything about\u00a0rental\u00a0homes.',
  'videoSection.subtitle':
    'Exceptionally well, so you won’t need to lift\u00a0a\u00a0finger.',
  'how-it-works.title': 'How It Works',
  'how-it-works.subtitle': 'Your Steps To Financial\u00a0Freedom',
  'testimonialsSection.title': `There's a lot of love to\u00a0go\u00a0around.`,
  'stepsSection1.title':
    'Enjoy monthly, guaranteed, long-term rental\u00a0income.',
  'stepsSection1.title-variant':
    'Why Belong? Your{region} Rental Deserves the\u00a0Best',
  'stepsSection1.subtitle-variant': 'Earn more. Stress\u00a0less.',
  'doTheMath.title': 'Get a feel for the guaranteed income you’ll\u00a0earn...',
  'doTheMath.cta': 'Get Rent Estimate',
  'lessVacancy.daysToLove':
    'Belong homes get loved in 21\u00a0days, on\u00a0average.',
  'lessVacancy.qualifiedApplicants':
    'Belong homes receive an average of 5 qualified\u00a0applications.',
  'lessVacancy.renews':
    '82% of Belong Residents renew their lease after\u00a0year\u00a01.',
  'stepsSection2.title': 'Your home, treated\u00a0as\u00a0our\u00a0own.',
  'stepsSection2.subtitle': 'No cutting corners. No\u00a0duct\u00a0tape.',
  'stepsSection2.sellPropertyBanner.title':
    'Thinking of selling down the\u00a0road?',
  'stepsSection2.sellPropertyBanner.body':
    'We can take care of that too! Apply management fees paid-to-date as a discount on our 6% brokerage\u00a0fee.',
  'stepsSection2.sellPropertyBanner.cta': 'LEARN MORE',
  'priceTable.title': 'Pricing aligned with\u00a0you.',
  'priceTable.subtitle': 'No gimmicks. Just\u00a0great\u00a0service.',
  'priceTable.showMore': 'Show More',
  'priceTable.showLess': 'Show Less',
  'priceTable.unlockButton': 'Unlock',
  'priceTable.toBeDetermined': 'TBD',
  'stepsSection3.title': 'Long-term renting, made\u00a0lovable.',
  'blogSection.title': 'Read Our Blog',
  'blogSection.ctaLabel': 'View All Articles',
  'map.title': 'Belong’s National Footprint',
  'map.title-variant': 'Our Local{region} Offices',
  'guarantedRentWithBelongXSection.topText':
    'Looking to manage the home\u00a0yourself?',
  'guarantedRentWithBelongXSection.title': 'Get Guaranteed Rent With',
  'guarantedRentWithBelongXSection.cta': 'LEARN MORE',

  'guaranteedTimeToLoveLanding.titlePrefix': 'Year-long',
  'guaranteedTimeToLoveLanding.titleHighlight': 'Guaranteed Rent',
  'guaranteedTimeToLoveLanding.titleSuffix': 'in 21 days\u00a0average.',
  'guaranteedTimeToLoveLanding.subtitle':
    'If we take more than 60 days, the placement fee is\u00a0on\u00a0us.',
  'guaranteedTimeToLoveLanding.v2.title':
    'The Best-Priced Rental\nHome Management Team',
  'guaranteedTimeToLoveLanding.v2.subtitle':
    'AI-Enhanced. 5% Management Fee. Guaranteed\u00a0Rent Sent\u00a0On\u00a0The\u00a01st.',
  'guaranteedTimeToLoveLanding.guaranteedRent':
    'The Best Priced Rental Home Management Platform. With Guaranteed\u00a0Rent.',
  'guaranteedTimeToLoveLanding.guaranteedRentText':
    'Get guaranteed rent for a year, even if your\u00a0Residents default, with eviction costs covered. We treat Belong Residents exceptionally well, helping them stay longer and care for your\u00a0home.',
  'guaranteedTimeToLoveLanding.guaranteedRentTextFixedFees':
    'Because we heavily vet Belong Residents, and treat them exceptionally well, we offer up to 3 months of Guaranteed Rent & Eviction Protection. If your residents default, you’ll continue receiving rent while we take care of the hard\u00a0stuff.',
  'guaranteedTimeToLoveLanding.regionText':
    'Property Management Made\u00a0Lovable',

  'guaranteedTimeToLoveLanding.photoWallStrings': [
    'Belong homes get loved in\n 21\u00a0days on\u00a0average.',
    'Belong homes receive an\n average of\n\u00a05\u00a0qualified\u00a0applications.',
    '82% of Belong Residents\n renew their\u00a01\u2011year\u00a0lease.',
  ],
  'guaranteedTimeToLoveLanding.belovedHome.title':
    "We take care of everything, so you don't\u00a0have\u00a0to.",
  'guaranteedTimeToLoveLanding.belovedHome.subtitle':
    'Your dedicated Concierge works with a team to offer 24/7 support, so you, your home, and your Residents are always taken care\u00a0of.',
  'guaranteedTimeToLoveLanding.belovedHome.contactInfo': '',
  'guaranteedTimeToLoveLanding.residentsTitle1': 'Residents you’ll love,\n',
  'guaranteedTimeToLoveLanding.residentsTitle2':
    'in 21\u00a0days or\u00a0less.',
  'guaranteedTimeToLoveLanding.cta': 'Get Residents',
  'guaranteedTimeToLoveLanding.residentsSubtitle':
    'Once your home is listed, you’ll have residents in 21 days or less. Our unique combination of cutting-edge technology and human touch uses true market data and real-time interest from potential residents to maximize listing prices.',
  'guaranteedTimeToLoveLanding.card1':
    'Residents In 21\u00a0Days Or\u00a0Less\u00a0Average',
  'guaranteedTimeToLoveLanding.card1Description':
    'Most of our homes get rented in 21 days. If it takes us longer than 60, the placement fee\u00a0is\u00a0on\u00a0us.',
  'guaranteedTimeToLoveLanding.card2': 'Guaranteed Rent,\nEvery\u00a0Month',
  'guaranteedTimeToLoveLanding.card2Subtitle':
    'Get it on the 1st with Lightning\u00a0Rent.',
  'guaranteedTimeToLoveLanding.card2Footnote':
    'Lightning Rent: $29.99 a month per Home, or included in Income\u00a0Lock.',
  'guaranteedTimeToLoveLanding.card2Description':
    'Monthly rental payments even if your Residents pay\u00a0late.',
  'guaranteedTimeToLoveLanding.card3': '24/7 Care For\nYour Home',
  'guaranteedTimeToLoveLanding.card3Description':
    'Concierge-level care for your home year\u00a0round.',
  'guaranteedTimeToLoveLanding.card4':
    'AI\u00a0Powered, Made And Loved By\u00a0People',
  'guaranteedTimeToLoveLanding.card4Description':
    'The latest AI technologies are integrated into every aspect of managing your\u00a0home, with the Belong team there when you need\u00a0them.',
};
